export default __webpack_public_path__ + "static/media/Img086.be30bab3.jpg";